import { render } from "./AccountVerify.vue?vue&type=template&id=7be90ba0&scoped=true"
import script from "./AccountVerify.vue?vue&type=script&lang=js"
export * from "./AccountVerify.vue?vue&type=script&lang=js"

import "./AccountVerify.vue?vue&type=style&index=0&id=7be90ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be90ba0"]])

export default __exports__